<svg
  viewBox="0 0 28.5 31.700001"
  version="1.1"
  id="svg8"
  sodipodi:docname="Logo_SLUB_icon.svg"
  inkscape:version="1.1 (c4e8f9ed74, 2021-05-24)"
  width="28.5"
  height="31.700001"
  xmlns:inkscape="http://www.inkscape.org/namespaces/inkscape"
  xmlns:sodipodi="http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd"
  xmlns="http://www.w3.org/2000/svg"
  xmlns:svg="http://www.w3.org/2000/svg"
>
  <defs id="defs12" />
  <sodipodi:namedview
    id="namedview10"
    pagecolor="#ffffff"
    bordercolor="#666666"
    borderopacity="1.0"
    inkscape:pageshadow="2"
    inkscape:pageopacity="0.0"
    inkscape:pagecheckerboard="0"
    showgrid="false"
    inkscape:zoom="2.7909921"
    inkscape:cx="15.585856"
    inkscape:cy="18.45222"
    inkscape:window-width="1920"
    inkscape:window-height="1080"
    inkscape:window-x="0"
    inkscape:window-y="0"
    inkscape:window-maximized="1"
    inkscape:current-layer="svg8"
    fit-margin-top="0"
    fit-margin-left="0"
    fit-margin-right="0"
    fit-margin-bottom="0"
  />
  <path
    fill="#ee0000"
    d="M 5.8,0 V 2.9 L 25.6,5.7 V 26.6 L 28.5,27 V 3.2 Z M 0,28.5 22.7,31.7 V 7.9 L 0,4.7 Z"
    id="path4"
  />
</svg>

<style>
  svg {
    margin-right: 0.5rem;
    height: 24px;
  }
</style>
